export const POSITIONS = {
  TOP_CENTER: 'topCenter',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM_CENTER: 'bottomCenter',
} as const;

export const VARIANTS = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  WARNING: 'Warning',
  INFO: 'Info',
} as const;

export const ACTIONS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
} as const;
